import {shallowEqual, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {capitalizeFirstLetter, pluralizeWord} from '~/common/utils';
import {Typography} from '~library/atoms/Typography';
import {Button} from '~library/atoms/Button';
import {DeleteBinLineIcon} from '~library/svg/DeleteBinLineIcon';
import {EditLineIcon} from '~library/svg/EditLineIcon';

import {RegistryVendor} from '~/ViewInvitation/common/RegistryVendor';
import {isPreview} from '~/ViewInvitation/utils';

import {
  selectForceShowModule,
  selectRegistryNote,
  selectRegistryRecipient,
} from '~/common/fabric/reducers/giftingOptions/selectors';
import {
  selectRegistryName,
  selectRegistryNote as selectRegistryNoteFromRegistry,
} from '~/common/fabric/reducers/registry/selectors';

import {link} from '~libSass/base/_exports.sass';

export const RegistryModule = (props) => {
  const {readonly, connectCTA, showHeader = true, inModal = false} = props;
  const history = useHistory();
  const {eventId} = useSelector((state) => state.eventDetails, shallowEqual);

  const registries = useSelector((state) => state.registry?.registries ?? []);

  const localRegistryName = useSelector(selectRegistryRecipient);
  const localRegistryNote = useSelector(selectRegistryNote);
  const forceShowModule = useSelector(selectForceShowModule);

  const storedRegistryName = useSelector(selectRegistryName);
  const storedRegistryNote = useSelector(selectRegistryNoteFromRegistry);

  const registryName = localRegistryName || storedRegistryName;
  const registryNote = localRegistryNote || storedRegistryNote;

  const giftRegistryType = useSelector(
    (state) => state.giftingOptions?.gift_registry_type ?? state.registry?.registry_type
  );
  const isWishlist = giftRegistryType === 'wishlist';
  const registryType = isWishlist ? 'wishlist' : 'registry';

  let moduleTitle = registryType === 'wishlist' ? 'Wishlist' : 'Gift Registry';
  if (registryName && registryName?.trim().length) {
    moduleTitle = `${capitalizeFirstLetter(registryName)}'s ${pluralizeWord(
      moduleTitle,
      registries.length
    )}`;
  }

  const preview = isPreview();

  if (!registries.length && !registryName && !forceShowModule) {
    return null;
  }

  return (
    <div className="submodule-registry">
      {preview && !readonly && (
        <div className="view-invitation__preview-cta multi">
          <Button
            variant="transparent"
            className="view-invitation__preview-cta"
            onClick={() => {
              window.dataLayer.push({
                event: 'registry_note_title_added',
              });
              history.push(`/${eventId}/gifting`);
            }}
            data-qa-id="edit-registries"
            ref={(elem) => {
              if (connectCTA) connectCTA('edit-registries', elem);
            }}
          >
            <EditLineIcon ratio={0.5} color={link} />
            Edit
          </Button>
          <span>|</span>
          <Button
            variant="transparent"
            className="view-invitation__preview-cta"
            data-qa-id="remove-registries"
            id="remove-registries"
            ref={(elem) => connectCTA && connectCTA('remove-registries', elem)}
          >
            <DeleteBinLineIcon ratio={0.5} color={link} />
            Remove
          </Button>
        </div>
      )}
      <div className="view-invitation__gifting-module__registry-wrapper">
        {showHeader && (
          <Typography
            variant="header3"
            classNames="view-invitation__registry-module-title"
            data-qa-id="registry-module-title"
          >
            {moduleTitle}
          </Typography>
        )}

        {registryNote && (
          <Typography variant="list1" className="view-invitation__registry-vendor__note">
            {registryNote}
          </Typography>
        )}

        <div
          className={`gift-registry__vendors view-invitation__registry-grid ${inModal ? 'scroll' : ''}`}
          data-qa-id="gift-registry__vendors"
        >
          {registries.map((registry, index) => (
            <RegistryVendor
              type={registryType}
              registry={registry}
              dataQaId="gift-registry-item"
              key={`${registry?.id ?? registry?.name}_${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
